import { render } from "./EyeOff.svg?vue&type=template&id=8acf9e34"
const script = {}
script.render = render

export default script